import { css } from 'linaria';
import { styled } from 'linaria/react';
import { UtpCardOrientation, UtpCardSize, UtpCardType } from './utp-card-types';

export const StyledUtpCard = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  && {
    @media (--only-mobile) {
      flex-direction: row;
    }

    & img {
      border-radius: 0 0 var(--rounding-l) 0;

      @media (--only-mobile) {
        width: 120px;
        height: 102px;
      }
    }
  }
`;

export const utpCardTypeMap: Record<UtpCardType, string> = {
  outline: css`
    border: 1px solid var(--control-minor);
    border-radius: 8px;
  `,
  secondary: css`
    background-color: var(--background-secondary);
    border-radius: var(--rounding-l);
    cursor: pointer;

    &:hover {
      background-color: var(--control-minor);
    }
  `,
  'service-light': css`
    background-color: var(--service-light);
    border-radius: var(--rounding-l);
    cursor: pointer;

    &:hover {
      background-color: #46c8e9;
    }
  `,
};

export const utpCardSizeMap: Record<UtpCardSize, string> = {
  l: css`
    height: 308px;
  `,
  s: css`
    height: 264px;
  `,
};

export const utpCardOrientationMap: Record<UtpCardOrientation, string> = {
  horizontal: css`
    flex-direction: row;

    & div:first-child {
      @media (--only-tablet) {
        padding-right: 14px;
      }
    }

    & img {
      @media (--from-desktop) {
        width: 152px;
        height: 130px;
      }

      @media (--only-tablet) {
        width: 140px;
        height: 120px;
      }
    }
  `,
  vertical: css`
    flex-direction: column;

    & img {
      @media (--from-tablet) {
        width: 168px;
        height: 144px;
      }
    }
  `,
};

export const UtpCardContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;

  @media (--only-mobile) {
    width: 52.5vw;
    padding: 16px;
  }
`;
